import Vue from 'vue'

$(() => {
  if (!$('.js-sns-urls-input').length) {
    return
  }
  const setupComponent = (id) => {

    new Vue({
      el: id,
      data: {
        youtubeUrl: "",
        instagramUrl: "",
        facebookUrl: "",
        twitterUrl: "",
        noteUrl: "",
        githubUrl: "",
        qiitaUrl: "",
        threadsUrl: "",
        pixivUrl: "",
        tiktokUrl: "",
        urls: ""
      },
      mounted() {
        let defaultUrls = $(id).data('default')
        if (!!defaultUrls) {
          this.youtubeUrl = defaultUrls.youtube
          this.instagramUrl = defaultUrls.instagram
          this.facebookUrl = defaultUrls.facebook
          this.twitterUrl = defaultUrls.twitter
          this.noteUrl = defaultUrls.note
          this.githubUrl = defaultUrls.github
          this.qiitaUrl = defaultUrls.qiita
          this.threadsUrl = defaultUrls.threads
          this.pixivUrl = defaultUrls.pixiv
          this.tiktokUrl = defaultUrls.tiktok
        }
        this.onUpdateParams()
      },
      methods: {
        onUpdateParams() {
          this.urls = JSON.stringify({
            youtube: this.youtubeUrl,
            instagram: this.instagramUrl,
            twitter: this.twitterUrl,
            facebook: this.facebookUrl,
            tiktok: this.tiktokUrl,
            threads: this.threadsUrl,
            note: this.noteUrl,
            github: this.githubUrl,
            qiita: this.qiitaUrl,
            pixiv: this.pixivUrl,
          })
        },
      }
    })
  }


  // 初期化
  $('.js-sns-urls-input').each((i, element) => {
    let id = $(element).attr('id')
    setupComponent('#' + id)
  })
})
